var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NinaData_logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.173,
    height: 31.922,
    viewBox: "0 0 31.173 31.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M31.8,37.266h4.03V33.2h1.819v4.066h3.995v1.855H37.649v4.1H35.83v-4.1H31.8Z",
    transform: "translate(-21.135 -22.25)",
    fill: "#5270a3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M59.8,36.657l1.569,1.605,4.958-5.029L61.4,28.239l-1.569,1.605,3.353,3.388Zm1.462,4.209L57.3,36.8l3.5-3.567-3.5-3.567L61.259,25.6l7.454,7.633Z",
    transform: "translate(-37.541 -17.361)",
    fill: "#5270a3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M4.325,33.333,9.283,28.3l1.569,1.605-3.388,3.46,3.353,3.388L9.247,38.362ZM1.9,33.3l7.454,7.6,3.995-4.03L9.854,33.3l3.5-3.567L9.39,25.7Z",
    transform: "translate(-1.9 -17.425)",
    fill: "#5270a3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M27.232,9.954l4.922-4.993L37.112,9.99,35.507,11.6l-3.388-3.46-3.353,3.388ZM32.154,2.5,24.7,10.1l3.959,4.066,3.5-3.567,3.5,3.567L39.609,10.1Z",
    transform: "translate(-16.568 -2.5)",
    fill: "#5270a3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M27.268,63.473l1.569-1.605,3.388,3.46,3.353-3.388,1.569,1.605-4.922,4.993Zm4.886-.606-3.5-3.567L24.7,63.366l7.454,7.6,7.454-7.6L35.65,59.3Z",
    transform: "translate(-16.568 -39.041)",
    fill: "#5270a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.ce17e0e2bb3932de3aa3a783250cbf98.svg";
export { ForwardRef as ReactComponent };